import { SERVER_API } from "../../Constant";
import axios from "axios";

export interface ReportByDateParams {
  startDate: string;
  endDate: string;
  addedUser?: number;
  customerId?: number;
  inquiryNumber?: string;
  engineNumber?: string;
  chassisNumber?: string;
  paymentMethod?: string;
  slipId?: string;
}

export const FetchReportByDate_api = async (params: ReportByDateParams) => {
    try {
        const response = await axios.get(
            `${SERVER_API}/Reports/fetch_report_by_date.php`,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                params,
            }
        );

        return response.data;
    } catch (error: any) {
        console.error("Fetch report by date failed:", error);
        return { error: "Fetch report by date failed" };
    }
};